import React from 'react';
import PropTypes from 'prop-types';
import SweetAlert from 'react-bootstrap-sweetalert';

import { makeStyles } from '@material-ui/core/styles';
import styles from 'assets/jss/material-dashboard-pro-react/components/dialogStyle';

const useStyles = makeStyles(styles);

const CustomDialog = ({
	title,
	children,
	onConfirm,
	onCancel,
	confirmBtnText = 'Save',
	cancelBtnText = 'Cancel',
	showIcon,
}) => {
	const classes = useStyles();

	return (
		<div>
			<SweetAlert
				warning={showIcon}
				style={{
					display: 'block',
					marginTop: '-100px',
				}}
				title={title}
				onConfirm={onConfirm}
				onCancel={onCancel}
				confirmBtnCssClass={`${classes.button} ${classes.dialogButton} ${classes.dialogConfirmButton} ${classes.success}`}
				cancelBtnCssClass={`${classes.button} ${classes.dialogButton} ${classes.gray}`}
				confirmBtnText={confirmBtnText}
				cancelBtnText={cancelBtnText}
				closeOnClickOutside={false}
				showCancel
			>
				{children}
			</SweetAlert>
		</div>
	);
};

export default CustomDialog;

CustomDialog.propTypes = {
	title: PropTypes.string.isRequired,
	children: PropTypes.any,
	onConfirm: PropTypes.func,
	onCancel: PropTypes.func,
	confirmBtnText: PropTypes.string,
	cancelBtnText: PropTypes.string,
	showIcon: PropTypes.bool,
};
